import React from 'react'

export default function InviteNotFound(props) {
    return (<h1 style={{textAlign: 'center'}}>Not Found</h1>)
}
